export const API_URLS = {
    STRIKE_PRICE: 'https://eweb8.vfd2-testnet.de/api/strikeprice/strikeprices'
};

export const VOUCHER_API_URL = 'https://eweb8.vfd2-testnet.de/api/vfd2dyn/json/voucherservice/voucherfc.php';

export const AUTH_NBA_API = '/api/commerce/authentication';

export const MTAN_PAGE_URL = '/shop/authentifizierung.html?btype=decide&configURL=%2Fscripts%2Fecommerce.config.auth.json';
